import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VesselDataService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    downloadVesselData(
        iApiShipyardId: string,
        iAPIVesselId: string,
        version: string,
        isCurrentVersion: boolean,
        vesselId: string
    ) {
        const params = {
            iApiShipyardId,
            iAPIVesselId,
            version,
            isCurrentVersion,
            vesselId,
        };
        return lastValueFrom(
            this.http.get(`${this.domain}/api/version-download`, {
                responseType: 'blob',
                params,
            })
        );
    }
}
